<template>
  <div id='news'>
    <NewsList></NewsList>
  </div>
</template>
<script>
import NewsList from '../components/news/NewsList'
export default {
  name: 'news',
  components: {
    NewsList,
  },
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/News.vue